<template>
  <div>
    <vs-card style="margin-bottom: 15px">
      <div slot="header">
        <h3>{{ gelenYil }} <vs-divider></vs-divider></h3>
      </div>
      <b-row align-v="center">
        <b-col lg="3" sm="5">
          <v-select
            v-model="secilenDurum"
            :options="durumList"
            @input="getbabsDetay"
            placeholder="Durum"
            style=""
          >
          </v-select>
        </b-col>

        <b-col lg="2" sm="2">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="getbabsDetay()"
            id="button-with-loading-yeni"
            class="vs-con-loading__container"
            >Listele</vs-button
          >
        </b-col>
        <b-col lg="3" sm="2">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="mailListEkle()"
            id="button-with-loading-mail"
            class="vs-con-loading__container"
            color="danger"
            icon="email"
            >Mail Listesine Ekle</vs-button
          >
        </b-col>
        <b-col lg="3" sm="2">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="smsListEkle()"
            id="button-with-loading-yeni"
            class="vs-con-loading__container"
            color="success"
            icon="send"
            >Sms Listesine Ekle</vs-button
          >
        </b-col>
      </b-row>
    </vs-card>
    <vx-card>
      <b-row align-h="end">
        <b-col cols="12" md="auto" style="padding: 0"
          ><vs-chip transparent color="primary"> Görüldü </vs-chip>
        </b-col>
        <b-col cols="12" md="auto" style="padding: 0"
          ><vs-chip transparent color="success"> Onaylandı </vs-chip>
        </b-col>
        <b-col cols="12" md="auto" style="padding: 0"
          ><vs-chip transparent color="danger"> Red Edildi </vs-chip>
        </b-col>
        <b-col cols="12" md="auto" style="padding: 0"
          ><vs-chip transparent color="warning"> Mail Gönderildi </vs-chip>
        </b-col>
      </b-row>
      <ag-grid-vue
        style="width: 100%; height: 450px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        :rowClassRules="rowClassRules"
        :rowSelection="rowSelection"
        @grid-ready="onGridReady"
        @selection-changed="onSelectionChanged"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vx-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import babsDetayUnvanCellRendere from "./CellRenderers/babsDetayUnvanCellRendere.vue";
import babsDetayBelgeCellRenderer from "./CellRenderers/babsDetayBelgeCellRenderer.vue";
import babsDetayMailCellRenderer from "./CellRenderers/babsDetayMailCellRenderer.vue";

export default {
  data() {
    return {
      rowSelection: null,
      secilenTalepler: [],
      gelenYil: "",
      rowClassRules: null,
      localeText: null,
      columnDefs: null,
      rowData: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      secilenDurum: "",
      durumList: [
        "Tüm Liste",
        "Mail Gönderilenler",
        "Görüntülenenler",
        "Onaylananlar",
        "Red Edilenler"
      ]
    };
  },
  components: {
    AgGridVue,
    "v-select": vSelect,
    babsDetayUnvanCellRendere,
    babsDetayBelgeCellRenderer,
    babsDetayMailCellRenderer
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenTalepler = selectedRows;
    },
    mailListEkle() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(vm.secilenTalepler);
      if (vm.secilenTalepler.length == 0) {
        // vs.loading.close("#button-with-loading-mail > .con-vs-loading");
        vs.notify({
          title: "Satın alma",
          text: "Seçim yapınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        vs.loading({
          background: "#f08182",
          color: "#fff",
          container: "#button-with-loading-mail",
          scale: 0.45
        });
        vm.secilenTalepler.forEach((val, index) => {
          const args = {
            token: Store.state.tokenId,
            durum: this.$route.params.item_id.GONDERIM,
            EBEYANBABSID: this.$route.params.item_id.EBEYANBABSID,
            ITEMNO: val.ITEMNO
          };
          console.log(args);
          soap.createClient(url, function(err, client) {
            client.INT_MailListEkle(args, function(err, result) {
              if (result.INT_MailListEkleResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }

              try {
                vm.veriler = JSON.parse(result.INT_MailListEkleResult);
                if (vm.veriler.response == "Ok") {
                  var list = JSON.parse(vm.veriler.jsonData);
                  vm.getbabsDetay();
                  vs.loading.close(
                    "#button-with-loading-mail > .con-vs-loading"
                  );
                } else {
                  vs.loading.close(
                    "#button-with-loading-mail > .con-vs-loading"
                  );
                }
              } catch (error) {
                vs.loading.close("#button-with-loading-mail > .con-vs-loading");
              }
            });
          });
        });
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getbabsDetay() {
      var vm = this;
      var vs = this.$vs;
      /*  vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });*/
      console.log(vm.secilenDurum);
      if (vm.secilenDurum == "") vm.secilenDurum = "Tüm Liste";
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        durum: vm.secilenDurum,
        EBEYANBABSID: this.$route.params.item_id.EBEYANBABSID
      };
      console.log(args);
      soap.createClient(url, function(err, client) {
        client.INT_BABSDETAY(args, function(err, result) {
          if (result.INT_BABSDETAYResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.INT_BABSDETAYResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.rowData = list;
              console.log(list);
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            } else {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    }
  },
  created() {
    this.rowSelection = "multiple";
    console.log(this.$route.params.item_id);
    this.gelenYil =
      this.$route.params.item_id.YIL +
      "/" +
      this.$route.params.item_id.AY +
      " - " +
      this.$route.params.item_id.GONDERIM;

    this.getbabsDetay();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowClassRules = {
      "yellow-row": 'data.ONAYDURUM == ""',
      "blue-row": 'data.ONAYDURUM == "Görüldü"',
      "green-row": 'data.ONAYDURUM == "Onaylandı"',
      "red-row": 'data.ONAYDURUM == "Red Edildi"'
    };
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        headerName: "BaBs",
        width: 100,
        field: "BABS",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] }
      },
      {
        headerName: "Ünvan",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        cellRenderer: "babsDetayUnvanCellRendere",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Belge Say",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "YILAY",
        cellRenderer: "babsDetayBelgeCellRenderer",
        filterParams: { buttons: ["apply", "reset"] }
      },
      {
        headerName: "Mail/GSM",
        field: "EMAIL",
        sortable: true,
        filter: "agDateColumnFilter",
        cellRenderer: "babsDetayMailCellRenderer",
        filterParams: { buttons: ["apply", "reset"] }
      },
      {
        headerName: "BaBs Durum",
        field: "ONAYKOD",
        sortable: true,
        filter: "agTextColumnFilter",

        valueFormatter: this.parseDate,
        filterParams: { buttons: ["apply", "reset"] }
      },
      {
        headerName: "Bakiye Durum",
        field: "ONAYDURUM",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned"
      }
    ];
  }
};
</script>
<style lang="scss">
.green-row {
  background-color: #48da89 !important;
}
.white-row {
  background-color: #fff !important;
}
.yellow-row {
  background-color: #ffb976 !important;
}

.red-row {
  background-color: #f08182 !important ;
}

.blue-row {
  background-color: #9e95f5 !important;
}
</style>
